/*
 * source: https://raw.githubusercontent.com/shypple/activeadmin_addons/master/app/assets/javascripts/activeadmin_addons/inputs/nested-select.js
 */

import configureSelect2 from "../../configureSelect2.js";

$.fn.select2.amd.define(
  "select2/data/nestedCustomAdapter",
  ["select2/data/array", "select2/utils"],
  function (ArrayData, Utils) {
    function CustomData($element, options) {
      CustomData.__super__.constructor.call(this, $element, options);
    }

    Utils.Extend(CustomData, ArrayData);

    CustomData.prototype.query = function (params, callback) {
      var data = { results: [] };
      var element = this.$element;
      var collection = element.data("collection");
      var parent = element.data("parent");
      var parentId = element.data("parent-id");

      collection.forEach(function (record) {
        var regex = new RegExp(params.term, "i");
        var matched = !!record.text.match(regex);

        if ((!parent || record[parent] == parentId) && matched) {
          data.results.push(record);
        }
      });

      callback(data);
    };

    CustomData.prototype.current = function (callback) {
      var currentOption = null;
      var element = this.$element;
      var selectedOption = element.data("selected");
      var collection = element.data("collection");
      var data = [];

      $.each(collection, function (index, option) {
        if (!!selectedOption && option.id == selectedOption.id) {
          currentOption = option;
          element.data("selected", null);
          return;
        }

        if (element.val() == option.id) {
          currentOption = option;
          return;
        }
      });

      if (currentOption) {
        data.push(currentOption);
      }

      callback(data);
    };

    return CustomData;
  }
);

var nestedSelectInitializer = function () {
  configureSelect2(document);

  $(document).on("has_many_add:after", function (event, container) {
    if (container === undefined) {
      container = event.detail.toggle;
    }

    configureSelect2(container);
  });
};

$(document).on("turbolinks:load", nestedSelectInitializer);
